import React, {Suspense} from "react";



import { Route, Switch} from 'react-router-dom'
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import  { authActions } from "./store/auth-slice";
import { initSocket, saveSocket, setFriendsList } from "./store/chat-actions";
import  openSocket from 'socket.io-client'
import  { chatActions } from "./store/chat-slice";
import Button from "./components/Button";
import animations from './pages/animations.module.css'



const Home = React.lazy(() => import('./pages/Home'))
const Login = React.lazy(() => import('./pages/Login'))
const Signup = React.lazy(() => import('./pages/Signup'))






function App() {
  const [socketObj, setSocketObj] = useState()

  const dispatch = useDispatch()
  
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn)
  let userId = useSelector(state => state.auth.userId)
  const token = useSelector(state => state.auth.token) || localStorage.getItem('token')
  const logUserOut = useSelector(state => state.auth.logUserOut)

  const socket = useSelector(state => state.chat.socket)



  useEffect(() => {
    if(!token) {
      dispatch(authActions.logout())
      return; 
    }

    // if there is a token then sign the user in
    if(!isLoggedIn && localStorage.getItem('isLoggedIn')){
      const token = localStorage.getItem('token')
      const userId = localStorage.getItem('userId')
      const name = localStorage.getItem('user-name')

      fetch('https://realyou.herokuapp.com/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        },
        body: JSON.stringify({'test': 'test'})
    }).then(response => {
      return response.json()
    }).then(data => {
      if(!data.errors) {
          dispatch(authActions.logout())
          return; 
      }
      dispatch(authActions.login({token: token, userId, name}))

      
    })

     

    }
  }, [token, dispatch, isLoggedIn])

  

  useEffect(() => {
    if(!token) return;
    setSocketObj( openSocket('https://realyou.herokuapp.com'))
    if(!userId) {
      dispatch(setFriendsList(localStorage.getItem('userId'), token))
      return;
    }
    dispatch(setFriendsList(userId, token))

  }, [userId, dispatch, token])
  
  useEffect(() => {
    if(!socketObj) return;
    setTimeout(() => {
      dispatch(initSocket(socketObj))
        
      socketObj.on('message', data => {
         dispatch(  chatActions.setMessageData({data: {...data, event: 'message'}})  )     
      })

      socketObj.on('liveText', data => {
       dispatch(  chatActions.setMessageData({data: {...data, event: 'liveText'}}) )      

      })

      socketObj.on('new-user-message', data => {
       dispatch(  chatActions.setMessageData({data: {...data, event: 'new-user-message'}})  )     

      })

        
    

    }, 1500)

  }, [dispatch, socketObj])




  useEffect(() => {
    if(!token || !socket) return
    // save socket id to the server in the user schema
    dispatch(saveSocket(token, socket.id))
    
  }, [dispatch, socket, token])

  
  const globalError = useSelector(state => state.chat.globalErr)

  
  const resetGlobalError = (e) => {
    e.stopPropagation();
    dispatch(chatActions.setGlobalError(null))
  }

  
  

  return <Fragment>
    {
      globalError && <div className='global-error' onClick={resetGlobalError} >
        <div onClick={e => e.stopPropagation()}  className='global-error-item'>
          <div onClick={e => e.stopPropagation()} className='global-error-item--message'>
            {globalError.includes('token <') ? 'Something went wrong! try again later': globalError}
           
            </div>
          <Button onClick={resetGlobalError} > OK </Button>
          </div>
        </div>
    }

    
    
     <Suspense fallback={<div style={{
        width: "100%",
        height: "100%",
        display: "grid", 
        gridTemplateRows: '1fr',
        gridTemplateColumns: '1fr',
        justifyContent: "center",
        alignItems: "center"
       }}>
      <div className={animations["lds-facebook"]}><div></div><div></div><div></div></div>

     </div>} >
    
    <Switch >


        <Route path='/' exact>{isLoggedIn && !logUserOut? <Home isLoggedIn={isLoggedIn} />: <Login /> }</Route>
        <Route path='/login' exact>{(!isLoggedIn && <Login />)
         || 
         <Home 
         socket={socketObj} 

        /> }</Route>
        <Route path='/signup' exact> { (!isLoggedIn && <Signup />) || <Home />} </Route>
      
    </Switch>
    </Suspense>

  </Fragment>
}

export default App;
